export const translations = {
  heading: {
    en: "Allowing an application to access your health information.",
    es: "Permitir que una aplicación acceda a su información de salud.",
  },
  ThirdPartyAppDevelopers: {
    en: "Third party App developers can create Apps to connect to our API that will make your Personal Information available to you.",
    es: "Los desarrolladores de aplicaciones de terceros pueden crear aplicaciones para conectarse a nuestra API para que tenga acceso a su información personal.",
  },
  asCurrentPlanMember: {
    en: "As a current Plan member, you may access this information by downloading an App you choose to your smart phone, tablet, computer or other similar device.",
    es: "Como asegurado de una cobertura vigente, puede acceder a esta información si descarga la aplicación que elija en su teléfono inteligente, tableta, computadora u otro dispositivo similar.",
  },
  thisDecision: {
    en: "This decision is up to you.",
    es: "La decisión depende de usted.",
  },
  incorrectPassword: {
    en: "We're sorry, the password you entered is incorrect. Please try again.",
    es: "Lo sentimos, la contraseña que ingresó es incorrecta. Inténtelo de nuevo.",
  },
  unableLoadApps: {
    en: "We’re unable to load your third-party application data.",
    es: "No podemos cargar los datos de la aplicación de terceros.",
  },
  sorryMessage: {
    en: "We’re sorry for the inconvenience. Please try again later.",
    es: "Disculpe las molestias. Vuelva a intentarlo más tarde.",
  },
  controlWhichApps: {
    en: "Control which third-party apps and sites can use your data.",
    es: "Controle qué aplicaciones y sitios de terceros pueden usar sus datos.",
  },
  servicesAccess: {
    en: (stateCode: string) =>
      `You gave these services access to some of your BCBS${stateCode} account data, including info that may be sensitive. Remove access for those you no longer trust to use.`,
    es: (stateCode: string) =>
      `Le otorgó permiso a estos servicios para acceder a algunos de los datos de su cuenta de BCBS${stateCode}, incluso a información que puede ser confidencial. Cancele el acceso a aquellos que ya no sean de su confianza.`,
  },
  disconnectQuestion: {
    en: (appName: string) => `Are you sure you want to disconnect ${appName}?`,
    es: (appName: string) => `¿Está seguro de que desea desconectarse ${appName}?`,
  },
  password: {
    en: "Password",
    es: "Contraseña",
  },
  cancel: {
    en: "Cancel",
    es: "Cancelar",
  },
  enterPassword: {
    en: "To disconnect, please enter your password. You can always reconnect at any time in the third-party application.",
    es: "Si desea desconectarse, ingrese su contraseña. Podrá volver a conectar la aplicación de terceros en cualquier momento.",
  },
  reenterPassword: {
    en: "Please re-enter your password",
    es: "Vuelva a ingresar su contraseña",
  },
  disconnectAllApps: {
    en: "Are you sure you want to disconnect all third-party applications?",
    es: "¿Está seguro de que desea desconectar todas las aplicaciones de terceros?",
  },
  disconnectAll: {
    en: "Disconnect All",
    es: "Desconectar todo",
  },
  disconnect: {
    en: "Disconnect",
    es: "Desconectar",
  },
  noConnectedApps: {
    en: "You have no connected apps",
    es: "No tiene ninguna aplicación conectada",
  },
  unknownError: {
    en: "Unknown while disconnect",
    es: "Desconocido mientras se desconecta",
  },
  connectedApps: {
    en: "Connected App and Sites",
    es: "Aplicaciones y sitios conectados",
  },
  allAppsDisconected: {
    en: "All apps have been disconnected.",
    es: "Se han desconectado todas las aplicaciones.",
  },
  termsOfUse: {
    en: "Terms of Use",
    es: "Términos de uso",
  },
  legaAndPrivacy: {
    en: "Legal & Privacy",
    es: "Aviso legal y privacidad",
  },
  NonDiscrimination: {
    en: "Non-Discrimination Notice",
    es: "Aviso de No discriminación",
  },
  privacyStatement: {
    en: "Privacy Statement",
    es: "Declaración de privacidad",
  },
  copyInfNotif: {
    en: "Copyright Infringement Notification",
    es: "Notificación de violación de derechos de autor",
  },
  medPolices: {
    en: "Medical Policies and Payment and Coding Policies",
    es: "Políticas médicas y Políticas de pago y codificación",
  },
  webAndMobileLegal: {
    en: "Web and Mobile Terms of Use",
    es: "Términos de uso para sitios web y dispositivos móviles",
  },
  webAndMobile: {
    en: "Web and Mobile Privacy Statement",
    es: "Declaración de privacidad para sitios web y dispositivos móviles",
  },
  backLabel: {
    en: "Back",
    es: "Volver",
  },
  personalInfo: {
    en: "Your Personal Information",
    es: "Su información personal",
  },
  name: {
    en: "Name",
    es: "Nombre",
  },
  address: {
    en: "Address",
    es: "Dirección",
  },
  dateOfBirth: {
    en: "Date Of Birth",
    es: "Fecha de nacimiento",
  },
  otherPersonalInfo: {
    en: "Other Personal Information",
    es: "Otra información personal",
  },
  coverageInformation: {
    en: "Your Coverage Information",
    es: "Información de su cobertura",
  },
  membershipDetails: {
    en: "Membership details",
    es: "Detalles de su cobertura",
  },
  planInformation: {
    en: "Plan Information",
    es: "Información de la cobertura",
  },
  otherCoverageInformation: {
    en: "Other Coverage Information",
    es: "Otro tipo de información sobre la cobertura",
  },
  prescriptionsAndMedications: {
    en: "Your Prescriptions and Medications",
    es: "Sus recetas y medicamentos recetados",
  },
  listOfPrescriptions: {
    en: "List of prescriptions and associated information",
    es: "Lista de medicamentos recetados e información asociada",
  },
  medicationRequested: {
    en: "Medication requested",
    es: "Medicamentos solicitados",
  },
  medicationDiesensed: {
    en: "Medication diesensed",
    es: "Medicamentos administrados",
  },
  clinicalInformation: {
    en: "Your Clinical Information",
    es: "Su información clínica",
  },
  allergies: {
    en: "Allergies",
    es: "Alergias",
  },
  carePlan: {
    en: "Care plan",
    es: "Cobertura médica",
  },
  careTeam: {
    en: "Care Team",
    es: "Equipo de atención médica",
  },
  conditions: {
    en: "Conditions",
    es: "Condiciones",
  },
  devices: {
    en: "Devices",
    es: "Dispositivos",
  },
  expireDevices: {
    en: "Expired Devices",
    es: "Dispositivos vencidos",
  },
  clinicalNotes: {
    en: "Clinical notes",
    es: "Notas clínicas",
  },
  healthGoals: {
    en: "Health Goals",
    es: "Objetivos de salud",
  },
  immunizationRecords: {
    en: "Immunization records",
    es: "Registros de vacunación",
  },
  locations: {
    en: "Locations",
    es: "Sucursales",
  },
  observations: {
    en: "Observations",
    es: "Observaciones",
  },
  practitionerRoles: {
    en: "Practitioner roles",
    es: "Funciones del profesional",
  },
  procedures: {
    en: "Procedures",
    es: "Procedimientos",
  },
  claimsInformation: {
    en: "Your Claims Information",
    es: "Información sobre reclamaciones",
  },
  explanationOfBenefits: {
    en: "Explanation of benefits",
    es: "Explicación de Beneficios",
  },
  providersAndPractitioners: {
    en: "Providers and practitioners",
    es: "Profesionales de la salud",
  },
  facilitiesAndOrganizations: {
    en: "Facilities and organizations",
    es: "Centros y organizaciones",
  },
  copyRight: {
    en: (year: number) => `© Copyright ${year} Health Care Service Corporation. All Rights Reserved.`,
    es: (year: number) => `© Copyright ${year} Health Care Service Corporation. Todos los derechos reservados.`,
  },
  securityCenter: {
    en: "Security Center",
    es: "Centro de seguridad",
  },
  securityCenterDescription: {
    en: "Below are all active trusted devices linked to your account. Be sure to remove devices you don’t recognize or no longer use.",
    es: "A continuación, se muestran todos los dispositivos activos de confianza vinculados a su cuenta. Asegúrese de eliminar los dispositivos que no reconoce o que ya no usa.",
  },
  expiredDevicesDescription: {
    en: "You can renew an expired device the next time you use it to log in.",
    es: "Puede renovar un dispositivo vencido la próxima vez que lo utilice para iniciar sesión.",
  },
  lastAccessed: {
    en: "Last accessed",
    es: "Último acceso",
  },
  operatingSystem: {
    en: "Operating System",
    es: "Sistema operative",
  },
  showLess: {
    en: "Less info",
    es: "Menos información",
  },
  showMore: {
    en: "More info",
    es: "Más información",
  },
  today: {
    en: "Today",
    es: "Today",
  },
  loginToMemberPortal: {
    en: "Log in to Member Portal",
    es: "Inicie sesión en el portal para asegurados",
  },
  removeDevice: {
    en: "Remove Device",
    es: "Eliminar dispositivo",
  },
  removePasskey: {
    en: "Remove Passkey",
    es: "Quitar clave de acceso",
  },
  removeSuccessMessage: {
    en: "You have successfully removed:",
    es: "Ha eliminado correctamente:",
  },
  namePassKey: {
    en: "Name this Passkey?",
    es: "¿Quiere ponerle un nombre a esta clave de acceso?",
  },
  passKeyName: {
    en: "Passkey Name",
    es: "Nombre de la clave de acceso",
  },
  namePassKeyInfo: {
    en: "You can add a nickname to easily identify this passkey from your security center.",
    es: "Puede agregar un apodo para identificar fácilmente esta clave de acceso desde su centro de seguridad.",
  },
  addPassKey: {
    en: "Add Passkey Name",
    es: "Agregar nombre de la clave de acceso",
  },
  addPasskeyButton: {
    en: "Add Passkey",
    es: "Agregar una clave de acceso",
  },
  addPasskeySuccessMessage: {
    en: "You have successfully added:",
    es: "Has agregado exitosamente:",
  },
  passkeySpecialCharactersAllowed: {
    en: "Only the following special characters allowed: ! @ # $ % ^ & * ' _ - , spaces",
    es: "Solo se permiten los siguientes caracteres especiales: ! @ # $ % ^ & * ' _ - , espacios",
  },
  minLength: {
    en: "Min length not met.",
    es: "No se alcanzó la longitud mínima.",
  },
  skipButton: {
    en: "Skip",
    es: "Saltar",
  },
  removePasskeyDialogTitle: {
    en: "Remove passkey from your account?",
    es: "¿Quiere eliminar la clave de acceso de su cuenta?",
  },
  removePasskeyDialogText: {
    en: "You can always readd passkeys to your account in the future. You’ll still need to delete this passkey from your device’s settings.",
    es: "Siempre podrá leer las claves de acceso a su cuenta en el futuro. Aun así, necesitará eliminar esta clave de acceso desde las configuraciones de su dispositivo.",
  },
  browser: {
    en: "Browser",
    es: "Navegador",
  },
  removeDeviceDialogTitle: {
    en: "Remove device from your account?",
    es: "¿Quiere eliminar el dispositivo de su cuenta?",
  },
  removeDeviceDialogText: {
    en: "You can always add devices again later by using them to log into your account.",
    es: "Puede volver a agregar dispositivos más tarde al usarlos para iniciar sesión en su cuenta.",
  },
  failedToRemove: {
    en: "We’re sorry, we couldn’t complete your request due to a network error. Please try again later.",
    es: "Lo sentimos, no pudimos completar su solicitud debido a un error de red. Vuelva a intentarlo más tarde.",
  },
  failedToFetch: {
    en: "We’re sorry, we can't display your trusted devices due to a network error. Please try again later.",
    es: "Lo sentimos, no podemos mostrar sus dispositivos seguros debido a un error de red. Vuelva a intentarlo más tarde.",
  },
  failedToFetchPasskey: {
    en: "We can’t access this device’s biometric/passkey feature due to a system issue. Please try again later.",
    es: "No podemos acceder a la función biométrica/clave de acceso de este dispositivo debido a un problema en el sistema. Vuelva a intentarlo más tarde.",
  },
  headingLogin: {
    en: "A simple, secure way to manage your care.",
    es: "Una forma sencilla y segura de administrar su atención médica.",
  },
  reviewClaims: {
    en: "Review your claims any time, anywhere.",
    es: "Revise sus reclamaciones en cualquier momento y lugar.",
  },
  getDocuments: {
    en: "Get documents online and updates to view them by email or text message.",
    es: "Obtenga documentos en línea y actualizaciones para consultarlas por correo electrónico o mensaje de texto.",
  },
  accessYourMember: {
    en: "Access your member ID card digitally.",
    es: "Acceder a su tarjeta de identificación de asegurado de forma digital.",
  },
};
